export enum RpLogicReportStepTypeEnum {

    QL_QUERY,
    LG_LOGIC

}
